import FramedIcon from '@passkeys/ui/framed-icon';
import Text from '@passkeys/ui/text';

import PickerModal from '@/ui/components/picker-modal';
import { ACTIVITY_TYPES } from '@/ui/constants';
import actions from '@/ui/flux/actions';
import type { ActivityTypeSelection } from '@/ui/pages/history/types';
import type { ActivityType } from '@/ui/types';

function renderActivityType(activityType: ActivityType) {
  return (
    <div className="flex items-center gap-x-2">
      <FramedIcon
        name={activityType.icon}
        size={32}
        shape="squared"
        forceLight
      />
      <Text>{activityType.label}</Text>
    </div>
  );
}

function showFilterActivityTypesModal({
  defaultTypes,
}: { defaultTypes?: ActivityType[] } = {}): {
  result: ActivityTypeSelection;
} {
  return actions.modal.show({
    title: 'Filter types',
    fullscreen: true,
    reactContent: (
      <PickerModal<ActivityType>
        multiple
        defaultSelected={defaultTypes}
        options={ACTIVITY_TYPES}
        getOptionKey={(activityType) => activityType.key}
        renderOption={renderActivityType}
        includeAllOption
        onClose={() => {}} // FIXME: Improve `reactContent` type to avoid having to pass `onClose` here.
        noSearch
      />
    ),
  });
}

export default showFilterActivityTypesModal;
